import { RouteComponentProps, useLocation } from '@reach/router';
import { ResourcesApi } from 'api/resourcesApi';
import Presentation from 'components/presentation/Presentation';
import ResourcePageStatus from 'components/resources/ResourcePageStatus';
import {
  isPageData,
  ResourcesRouteParams,
  toId,
  usePageTitle,
  useResourcesPage,
} from 'components/resources/resourcesHelpers';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import queryString from 'query-string';
import React from 'react';

type Props = RouteComponentProps<ResourcesRouteParams>;

const ResourcePresentation: React.FC<Props> = ({ subject: subjectCode }) => {
  const { search } = useLocation();
  const resourcesId = toId(queryString.parse(search).resourceId);
  const result = useResourcesPage(
    subjectCode,
    resourcesId === null
      ? null
      : (subjectsId) => ResourcesApi.getPresentation(subjectsId, resourcesId),
    String(resourcesId)
  );
  usePageTitle(isPageData(result) ? `${result.subject.name} - Resource Bank` : null);

  if (!isPageData(result)) return <ResourcePageStatus result={result} />;
  if (result.details.slides.length === 0) return <ResourcePageStatus result="notFound" />;

  return (
    <SubjectSiteLayout colorCss="Blue_GSFPE">
      <Presentation slides={result.details.slides} />
    </SubjectSiteLayout>
  );
};

export default ResourcePresentation;
